import * as React from 'react'
import * as OrderStatus from '../../../Entities/OrderStatus'
import {GeneralInformationSubAction} from './GeneralInformationActions'
import {GeneralInformationTab} from './GeneralInformationState'
import * as Editable from '../../../Data/Editable'
import RaisedButton from 'material-ui/RaisedButton'
import List from 'material-ui/List/List'
import ListItem from 'material-ui/List/ListItem'
import ImagePictureAsPdf from 'material-ui/svg-icons/image/picture-as-pdf'
import Checkbox from 'material-ui/Checkbox'
import {OrderWithDetails} from '../../../Entities/OrderWithDetails'
import FlatButton from 'material-ui/FlatButton'
import Divider from 'material-ui/Divider'
import Card from 'material-ui/Card/Card'
import creiosTheme from '../../../Theme/creiosTheme'
import ToggleCheckBoxOutlineBlank from 'material-ui/svg-icons/toggle/check-box-outline-blank'
import injectSheet from 'react-jss'
import {card, tabs} from '../../../Style'
import {EditableTextField} from '../../../View/EditableTextField'

const styles = {
    ...tabs,
    ...card
}

interface Props {
    readonly orderWithDetails: OrderWithDetails,
    readonly state: GeneralInformationTab,
    readonly dispatch: (action: GeneralInformationSubAction) => void,

}

export const GeneralInformationTabView =
    injectSheet<Props>(styles)(
        ({classes, state, dispatch, orderWithDetails}) => {
            const
                {order, customer, company, bpsUser} = orderWithDetails,
                {generalInformation, generalInformationForm} = state,
                orderDetails = Editable.withDefault(generalInformation, generalInformationForm)
            return (
                <div className={classes.tabContent}>
                    <form className={classes.tabForm}>
                        <Card
                            className={classes.card}
                        >
                            <div className={classes.cardHeader}>
                                Übersicht
                            </div>
                            <div className={classes.cardContent}>
                                {(() => {
                                    switch (state.orderPaid) {
                                        case 'Unpaid':
                                            return (
                                                <OrderPaidCheckbox
                                                    paid={false}
                                                    dispatch={dispatch}
                                                />
                                            )
                                        case 'Paid':
                                            return (
                                                <OrderPaidCheckbox
                                                    paid={true}
                                                    dispatch={dispatch}
                                                />
                                            )
                                        case 'Credited':
                                            return (
                                                <p>
                                                    Auftrag wurde gutgeschrieben
                                                </p>
                                            )

                                    }
                                })()}
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Datum"
                                    locked={true}
                                    value={order.orderPaidMarkedDate !== null ?
                                        order.orderPaidMarkedDate.toLocalDate().toString() :
                                        ''}
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Status"
                                    locked={true}
                                    value={OrderStatus.label(order.status)}
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Kunde"
                                    locked={true}
                                    value={customer.longName}
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Gesellschaft"
                                    locked={true}
                                    value={`${company.name1} ${company.name2}`}
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Besteller"
                                    locked={true}
                                    value={bpsUser.firstName + ' ' + bpsUser.lastName}
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Gewicht"
                                    locked={true}
                                    value="100g"
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Gewicht"
                                    locked={true}
                                    value="100g"
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Warenwert (Netto)"
                                    locked={true}
                                    value={order.netPrice.toFixed(2) + ' €'}
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Lieferkosten (Netto)"
                                    locked={true}
                                    value="3,30€"
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="UstID"
                                    locked={true}
                                    value={orderDetails.vatId === null ? '' : orderDetails.vatId}
                                    onChange={event => dispatch({
                                        type: 'OrderVatIdChanged',
                                        value: event.currentTarget.value
                                    })}
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Versand"
                                    locked={true}
                                    value={order.shippingMethod}
                                />
                                <EditableTextField
                                    className={classes.tabInput}
                                    label="Extra"
                                    locked={true}
                                    value="International"
                                />
                            </div>
                            <div className={classes.cardFooter}>
                                <FlatButton
                                    icon={<ImagePictureAsPdf/>}
                                    label="Lieferschein"
                                    style={{marginRight: '10px'}}
                                    labelPosition={'after'}
                                />
                                <RaisedButton
                                    label="neu generieren"
                                    primary={true}
                                />
                            </div>
                        </Card>
                    </form>
                    <form className={classes.tabForm}>
                        <Card className={classes.card}>
                            <div className={classes.cardHeader}>
                                Dateien
                            </div>
                            <List style={{marginTop: '24px'}}>
                                <ListItem
                                    primaryText="Datei.pdf"
                                    leftIcon={<ImagePictureAsPdf/>}
                                />
                                <Divider/>
                                <ListItem
                                    primaryText="Datei2.pdf"
                                    leftIcon={<ImagePictureAsPdf/>}
                                />
                                <Divider/>
                                <ListItem
                                    primaryText="Datei3.pdf"
                                    leftIcon={<ImagePictureAsPdf/>}
                                />
                                <Divider/>
                                <ListItem
                                    primaryText="IchBinEinPDF-2017-06-05.pdf"
                                    leftIcon={<ImagePictureAsPdf/>}
                                />
                                <RaisedButton
                                    label="Datei hinzufügen"
                                    primary={true}
                                    style={{margin: '32px 24px'}}
                                />
                            </List>
                        </Card>
                    </form>
                </div>

            )
        }
    )

function OrderPaidCheckbox({paid, dispatch}: {
    paid: boolean,
    dispatch: (action: GeneralInformationSubAction) => void,
}) {
    return (
        <Checkbox
            style={{
                margin: '40px 0'
            }}
            label="Bezahlt"
            iconStyle={{fill: creiosTheme.palette.successColor}}
            className="payed-checkbox"
            checked={paid}
            onCheck={(event, checked) => dispatch({
                type: 'OrderPaidChanged',
                checked,
            })}
            uncheckedIcon={
                <ToggleCheckBoxOutlineBlank
                    style={{fill: creiosTheme.palette.errorColor}}
                />}
        />
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderDetails/GeneralInformation/GeneralInformationView.tsx